import { render } from "./format_numbers.vue?vue&type=template&id=30ae130f&scoped=true"
import script from "./format_numbers.vue?vue&type=script&lang=js"
export * from "./format_numbers.vue?vue&type=script&lang=js"

import "./format_numbers.vue?vue&type=style&index=0&id=30ae130f&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ae130f"]])

export default __exports__